import React from 'react';
import PageSidebar, { SidebarSection } from '../PageSidebar';

interface SidebarProps {
  expandedSection: string | null;
  activeContent: string;
  onToggleSection: (section: string) => void;
  onMenuItemClick: (contentId: string) => void;
  theme: 'light' | 'dark';
}

const MCP_SECTIONS: SidebarSection[] = [
  {
    key: 'mcp-server',
    label: 'MCP Server',
    items: [
      { label: 'Model Context Protocol', id: 'model-context-protocol' },
      { label: 'What is MCP', id: 'what-is-mcp' },
      { label: 'Availity MCP Server', id: 'availity-mcp-server' },
      { label: 'Supported API', id: 'supported-api' },
      { label: 'Quick start', id: 'quick-start' },
      { label: 'Demo flow', id: 'demo-flow' },
    ],
  },
];

const Sidebar = (props: SidebarProps): JSX.Element => (
  <PageSidebar {...props} sections={MCP_SECTIONS} />
);

export default Sidebar;
